import imageDroneOne from "./imageDroneOne.png";
import imageDroneTwo from "./imageDroneTwo.png";
import logo from "./logo.svg";

export default {
  imageDroneOne,
  imageDroneTwo,
  logo,
};
